type Props = {
    awaitingReply: boolean;
    previewBody: string | null;
    onReply: () => void;
};

/** Block 2 — only when awaitingReply. Never an empty strip. */
const MenteeDashboardReplyStrip = ({ awaitingReply, previewBody, onReply }: Props) => {
    if (!awaitingReply) {
        return null;
    }

    return (
        <>
        
        <div className="card border-primary border-opacity-25 shadow-sm rounded-3 p-3 mb-3 bg-white">
              <div className="d-flex flex-wrap flex-sm-nowrap align-items-center gap-3">
                <i className="bi bi-chat-dots-fill bg-primary bg-opacity-10 text-primary rounded-3 p-3 fs-4"></i>
                <div className="flex-grow-1">
                  <h6 className="fw-bold mb-1 text-dark">You have a message from your mentor</h6>
                  <p className="text-secondary small mb-0">"Hi Sneha! So glad to be connected with you. Looking forward to supporting your journey in finance and IB…"</p>
                  {previewBody ? <p className="text-secondary small mb-0">“{previewBody}”</p> : null}
                </div>
                <button className="btn btn-primary btn-sm font-500 px-3 py-2 text-nowrap rounded-pill d-flex align-items-center gap-1" onClick={onReply}>
                    Read &amp; Reply <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>
        </>
    );
};

export default MenteeDashboardReplyStrip;
